// extracted by mini-css-extract-plugin
export default {"postReport":"PostReport_postReport__G0CpM","contentTitle":"PostReport_contentTitle__2m2uQ","content":"PostReport_content__lPYKK","backButton":"PostReport_backButton__u7Ha7"};